import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { RetailHubHomeComponent } from '../Dashboard/components/home/retailhub-home.component';
import { RetailHubManageProjectsComponent } from '../Dashboard/components/manage-projects/retailhub-manage-projects.component';
import { RetailHubManageSalesplanComponent } from '../Dashboard/components/manage-salesplan/retailhub-manage-salesplan.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RetailhubAdhocTemplateComponent } from './components/adhoc-template/retailhub-adhoc-template.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
@NgModule({
  declarations: [
    RetailHubHomeComponent,
    RetailHubManageProjectsComponent,
    RetailHubManageSalesplanComponent,
    RetailhubAdhocTemplateComponent
  ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    MultiSelectModule,
    CalendarModule,
    FormsModule,
    ReactiveFormsModule,
    ConfirmDialogModule
  ]
})
export class DashboardModule { }
